import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import PaymentOutgoingActions, { paymentActionTypes } from '@Actions/paymentOutgoingActions';
import TrackerActions from '@Actions/trackerActions';
import PaymentOutgoingServices from '@Services/paymentOutgoingServices';
import { analytics } from '@Apis/constants';

/**
 * @param action
 */
function* _getPaymentsOutgoing(action) {
  try {
    yield put(PaymentOutgoingActions.getPaymentsOutgoingLoading(true));
    const paymentOutgoing = yield PaymentOutgoingServices.getPaymentsOutgoing(
      action?.page, action?.limit, action?.tenantId, action?.tenantSellerId, action?.status, action?.tenantRoleId, action?.approvalStatus, action?.paymentType, action?.searchKeyword, action?.customerId, action?.sellerId, action?.isExpense,action?.appliedPaymentType,
    );
    yield put(PaymentOutgoingActions.getPaymentsOutgoingSuccess(paymentOutgoing));
    yield put(PaymentOutgoingActions.getPaymentsOutgoingLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.getPaymentsOutgoingLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.GET_PAYMENTS_OUTGOING.ERROR, error));
  }
}

/**
 *
 */
function* getPaymentsOutgoing() {
  yield takeEvery(paymentActionTypes.GET_PAYMENTS_OUTGOING.REQUEST, _getPaymentsOutgoing);
}

/**
 * @param action
 */
function* _getApprovedOnlinePayments(action) {
  try {
    yield put(PaymentOutgoingActions.getApprovedOnlinePaymentsLoading(true));
    const approvedOnlinePayments = yield PaymentOutgoingServices.getApprovedOnlinePayments(
      action?.page, action?.limit, action?.tenantId, action?.tenantRoleId,
    );
    yield put(PaymentOutgoingActions.getApprovedOnlinePaymentsSuccess(approvedOnlinePayments));
    yield put(PaymentOutgoingActions.getApprovedOnlinePaymentsLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.getApprovedOnlinePaymentsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.GET_APPROVED_ONLINE_PAYMENTS.ERROR, error));
  }
}

/**
 *
 */
function* getApprovedOnlinePayments() {
  yield takeEvery(paymentActionTypes.GET_APPROVED_ONLINE_PAYMENTS.REQUEST, _getApprovedOnlinePayments);
}

/**
 * @param action
 */
function* _getPaymentOutgoingById(action) {
  try {
    yield put(PaymentOutgoingActions.getPaymentOutgoingByIdLoading(true));
    const paymentOutgoing = yield PaymentOutgoingServices.getPaymentOutgoingById(action?.tenantId, action?.paymentId, action?.paymentType);
    yield put(PaymentOutgoingActions.getPaymentOutgoingByIdSuccess(paymentOutgoing?.payments[0]));
    if (action?.callback) {
      action.callback(paymentOutgoing?.payments[0]);
    }
    yield put(PaymentOutgoingActions.getPaymentOutgoingByIdLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.getPaymentOutgoingByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.GET_PAYMENT_OUTGOING_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getPaymentOutgoingById() {
  yield takeEvery(paymentActionTypes.GET_PAYMENT_OUTGOING_BY_ID.REQUEST, _getPaymentOutgoingById);
}

/**
 * @param action
 */
function* _createPaymentsOutgoing(action) {
  try {
    yield put(PaymentOutgoingActions.createPaymentsOutgoingLoading(true));
    const payment = yield PaymentOutgoingServices.createPaymentsOutgoing(action.payload);
    if (payment.success) {
      yield put(TrackerActions.trackAction(paymentActionTypes.CREATE_PAYMENTS_OUTGOING.SUCCESS, payment.data));
      notification.open({
        type: 'success',
        message: 'payment Successfully added',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(payment);
      }
    } else {
      notification.open({
        type: 'error',
        message: payment.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.createPaymentsOutgoingLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.createPaymentsOutgoingLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.CREATE_PAYMENTS_OUTGOING.ERROR, error));
  }
}

/**
 *
 */
function* createPaymentsOutgoing() {
  yield takeLatest(paymentActionTypes.CREATE_PAYMENTS_OUTGOING.REQUEST, _createPaymentsOutgoing);
}

/**
 * @param action
 */
function* _updatePaymentsOutgoingLoading(action) {
  try {
    yield put(PaymentOutgoingActions.updatePaymentsOutgoingLoading(true));
    const payment = yield PaymentOutgoingServices.updatePaymentsOutgoing(action.payload);
    if (payment.success) {
      yield put(TrackerActions.trackAction(paymentActionTypes.UPDATE_PAYMENTS_OUTGOING.SUCCESS, payment.data));
      notification.open({
        type: 'success',
        message: 'payment Successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback(payment.payment);
      }
    } else {
      notification.open({
        type: 'error',
        message: payment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.updatePaymentsOutgoingLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.updatePaymentsOutgoingLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.UPDATE_PAYMENTS_OUTGOING.ERROR, error));
  }
}

/**
 *
 */
function* updatePaymentsOutgoing() {
  yield takeLatest(paymentActionTypes.UPDATE_PAYMENTS_OUTGOING.REQUEST, _updatePaymentsOutgoingLoading);
}

/**
 * @param action
 */
function* _deletePaymentOutgoing(action) {
  try {
    yield put(PaymentOutgoingActions.deletePaymentOutgoingLoading(true));
    const payment = yield PaymentOutgoingServices.deletePaymentOutgoing(action.paymentId);
    if (payment.success) {
      notification.open({
        type: 'success',
        message: 'Payment deleted Successfully!',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: payment.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.deletePaymentOutgoingLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.deletePaymentOutgoingLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.DELETE_PAYMENT_OUTGOING.ERROR, error));
  }
}

/**
 *
 */
function* deletePaymentOutgoing() {
  yield takeLatest(paymentActionTypes.DELETE_PAYMENT_OUTGOING.REQUEST, _deletePaymentOutgoing);
}

/**
 * @param action
 */
function* _createAndLinkPayment(action) {
  try {
    yield put(PaymentOutgoingActions.createAndLinkPaymentLoading(true));
    const payment = yield PaymentOutgoingServices.createAndLinkPayment(action.payload);
    if (payment.success) {
      yield put(TrackerActions.trackAction(paymentActionTypes.CREATE_AND_LINK_PAYMENT.SUCCESS, payment.data));
      notification.open({
        type: 'success',
        message: 'Payment Created Successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(payment);
      }
    } else {
      notification.open({
        type: 'error',
        message: payment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.createAndLinkPaymentLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.createAndLinkPaymentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.CREATE_AND_LINK_PAYMENT.ERROR, error));
  }
}

/**
 *
 */
function* createAndLinkPayment() {
  yield takeLatest(paymentActionTypes.CREATE_AND_LINK_PAYMENT.REQUEST, _createAndLinkPayment);
}

/**
 * @param action
 */
function* _linkPayment(action) {
  try {
    yield put(PaymentOutgoingActions.linkPaymentLoading(true));
    const payment = yield PaymentOutgoingServices.linkPayment(action.payload);
    if (payment.success) {
      notification.open({
        type: 'success',
        message: 'Linked payment Successfully !',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: payment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.linkPaymentLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.linkPaymentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.LINK_PAYMENT.ERROR, error));
  }
}

/**
 *
 */
function* linkPayment() {
  yield takeLatest(paymentActionTypes.LINK_PAYMENT.REQUEST, _linkPayment);
}

/**
 * @param action
 */
function* _unLinkPayment(action) {
  try {
    yield put(PaymentOutgoingActions.unLinkPaymentLoading(true));
    const payment = yield PaymentOutgoingServices.unLinkPayment(action.grnPaymentId);
    if (payment?.success) {
      notification.open({
        type: 'success',
        message: 'Unlinked payment Successfully!',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: payment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.unLinkPaymentLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.unLinkPaymentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.UNLINK_PAYMENT.ERROR, error));
  }
}

/**
 *
 */
function* unLinkPayment() {
  yield takeLatest(paymentActionTypes.UNLINK_PAYMENT.REQUEST, _unLinkPayment);
}

/**
 * @param action
 */
function* _updatePaymentsOutgoingStatus(action) {
  try {
    yield put(PaymentOutgoingActions.updatePaymentsOutgoingStatusLoading(true));
    const payment = yield PaymentOutgoingServices.updatePaymentOutgoingStatus(action.payload);
    if (payment.success) {
      notification.open({
        type: 'success',
        message: 'Payment status updated Successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(payment);
      }
    } else {
      notification.open({
        type: 'error',
        message: payment?.messages,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.updatePaymentsOutgoingStatusLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.updatePaymentsOutgoingStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.messages,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.UPDATE_PAYMENT_OUTGOING_STATUS.ERROR, error));
  }
}

/**
 *
 */
function* updatePaymentsOutgoingStatus() {
  yield takeLatest(paymentActionTypes.UPDATE_PAYMENT_OUTGOING_STATUS.REQUEST, _updatePaymentsOutgoingStatus);
}

/**
 * @param action
 */
function* _updatePaymentOutgoingWorkflow(action) {
  try {
    yield put(PaymentOutgoingActions.updatePaymentOutgoingWorkflowLoading(true));
    const payment = yield PaymentOutgoingServices.updatePaymentOutgoingWorkflow(action.payload);
    if (payment.success) {
      notification.open({
        type: 'success',
        message: 'Payment workflow updated Successfully !',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(payment);
      }
    } else {
      notification.open({
        type: 'error',
        message: payment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.updatePaymentOutgoingWorkflowLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.updatePaymentOutgoingWorkflowLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(paymentActionTypes.UPDATE_PAYMENT_OUTGOING_WORKFLOW.ERROR, error));
  }
}

/**
 *
 */
function* updatePaymentOutgoingWorkflow() {
  yield takeLatest(paymentActionTypes.UPDATE_PAYMENT_OUTGOING_WORKFLOW.REQUEST, _updatePaymentOutgoingWorkflow);
}

/**
 *
 */
// unlink PO advance payment

function* _unlinkPOAdvancePayment(action) {
  try {
    yield put(PaymentOutgoingActions.unlinkPOAdvancePaymentLoading(true));
    const unlinkPO = yield PaymentOutgoingServices.unlinkPOAdvancePayment(action.payload);
    if (unlinkPO.success) {
      notification.open({
        type: 'success',
        message: 'Payment workflow updated Successfully !',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(unlinkPO);
      }
    } else {
      notification.open({
        type: 'error',
        message: unlinkPO?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.unlinkPOAdvancePaymentLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.unlinkPOAdvancePaymentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* unlinkPOAdvancePayment() {
  yield takeLatest(paymentActionTypes.UNLINK_PO_ADVANCE_PAYMENT.REQUEST, _unlinkPOAdvancePayment);
}

// download payment outgoing

function* _downloadPaymentOutgoing(action) {
  try {
    yield put(PaymentOutgoingActions.downloadPaymentOutgoingLoading(true));
    const downloadPayment = yield PaymentOutgoingServices.downloadPaymentOutgoing(action.payload);
    if (downloadPayment.success) {
      notification.open({
        type: 'success',
        message: 'Your request is being processed. You will receive the data on your email.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(downloadPayment);
      }
    } else {
      notification.open({
        type: 'error',
        message: downloadPayment?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(PaymentOutgoingActions.downloadPaymentOutgoingLoading(false));
  } catch (error) {
    yield put(PaymentOutgoingActions.downloadPaymentOutgoingLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* downloadPaymentOutgoing() {
  yield takeLatest(paymentActionTypes.DOWNLOAD_PAYMENT_OUTGOING.REQUEST, _downloadPaymentOutgoing);
}

export default function* paymentSaga() {
  yield all([
    getPaymentsOutgoing(),
    createPaymentsOutgoing(),
    updatePaymentsOutgoing(),
    updatePaymentsOutgoingStatus(),
    deletePaymentOutgoing(),
    createAndLinkPayment(),
    linkPayment(),
    unLinkPayment(),
    updatePaymentOutgoingWorkflow(),
    getPaymentOutgoingById(),
    getApprovedOnlinePayments(),
    unlinkPOAdvancePayment(),
    downloadPaymentOutgoing(),
  ]);
}
